import React from 'react';

export const ProjectDocumentsContext = React.createContext({});

export const useProjectDocumentsContext = () =>
  React.useContext(ProjectDocumentsContext);
